import { gql } from '@apollo/client';

// We query by license -> program instead of program directly because graphql with better optimize (N+1)
// else, django would djnamically call additional query when accessing study_group.program property, thus
// an additional query
const DASHBOARD_STUDYGROUPS_AND_PINNIGS = gql`
  query DashboardQuery(
    $userId: String!
    $loadPinnings: Boolean!
    $limit: Int!
    $offset: Int! = 0
    $customFilters: StudyGroupFilter
  ) {
    studyGroups(
      pagination: { limit: $limit, offset: $offset }
      filters: $customFilters
      order: { updatedAt: DESC }
    ) {
      id
      name
      isSelfLearning
      isExplore
      isChallenge
      license {
        school {
          id
          name
        }
        period {
          id
          name
          lastDate
        }
        program {
          id
          name
          image {
            name
          }
          thumbnails
          description
        }
      }
    }
    pinnings(filters: { user: { id: $userId } }) @include(if: $loadPinnings) {
      id
      content {
        id
        name
        mediaType
      }
      studyGroup {
        id
        program {
          id
        }
      }
    }
  }
`;

const DASHBOARD_GLOBAL_STUDY_GROUPS = gql`
  query DashboardGlobalPrograms($enrolledOrTeacher: Boolean!) {
    globalStudyGroups(enrolledOrTeacher: $enrolledOrTeacher) {
      id
      name
      license {
        school {
          id
          name
        }
        program {
          id
          name
          image {
            name
          }
          thumbnails
          description
        }
      }
    }
  }
`;

const DASHBOARD_BLOG_STUDY_GROUPS = gql`
  query DashboardExploreStudyGroups {
    exploreStudyGroups {
      id
      name
      isExplore
      isSelfLearning
      isChallenge
      license {
        school {
          id
          name
        }
        program {
          id
          name
          image {
            name
          }
          thumbnails
          description
          programUnits {
            id
            name
            description
            thumbnails
            modules {
              id
              name
              contents {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

const CHALLENGE_SCHOOLS = gql`
  query ChallengeSchools {
    challengeSchools {
      id
      name
    }
  }
`;

const AVAILABLE_CHALLENGE_STUDY_GROUP = gql`
  query AvailableChallengeStudyGroup {
    availableChallengeStudyGroup {
      pk
      name
      license {
        school {
          name
        }
      }
      inviteCode
    }
  }
`;

const CHALLENGE_PROGRAMS = gql`
  query ChallengePrograms {
    programs(filters: { isChallenge: true }) {
      name
      id
      isChallenge
      description
      namespaces
    }
  }
`;

const PUBLIC_PROGRAMS = gql`
  query PublicPrograms {
    programs(filters: { isPublic: true }) {
      name
      id
      isChallenge
      isPublic
      description
      namespaces
      thumbnails
    }
  }
`;

const PUBLIC_UNITS = gql`
  query PublicUnits {
    units(filters: { isPublic: true }) {
      name
      id
      description
      thumbnails
      color
      isPublished
  }
}
`;

const TEACHER_TRAINING_PROGRAMS = gql`
  query TeacherTrainingPrograms {
    programs(filters: { isTeacherTraining: true }) {
      name
      id
      isChallenge
      isTeacherTraining
      description
      namespaces
    }
  }
`;

const LEADERBOARD_DATA = gql`
  query LeaderboardDataQuery {
    challengePoints
  }
`;

const DASHBOARD_CHALLENGE_STUDY_GROUPS = gql`
  query DashboardChallengeStudyGroups {
    challengeStudyGroups {
      id
      name
      isExplore
      isSelfLearning
      isChallenge
      license {
        school {
          id
          name
        }
        program {
          id
          name
          image {
            name
          }
          thumbnails
          description
          programUnits {
            id
            name
            description
            thumbnails
            modules {
              id
              name
              contents {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

const ARTICLES_QUERY = gql`
  query Articles {
    articles(filters: { isPublished: true }) {
      id
      pk
      name
      type
      namespace
    }
  }
`;

const EVENTS_QUERY = gql`
  query Events {
    events {
      id
      title
      image {
        name
        url
      }
      description
      endDatetime
      link
      namespace
      startDatetime
    }
  }
`;

export {
  DASHBOARD_STUDYGROUPS_AND_PINNIGS,
  DASHBOARD_BLOG_STUDY_GROUPS,
  DASHBOARD_CHALLENGE_STUDY_GROUPS,
  DASHBOARD_GLOBAL_STUDY_GROUPS,
  ARTICLES_QUERY,
  EVENTS_QUERY,
  AVAILABLE_CHALLENGE_STUDY_GROUP,
  CHALLENGE_SCHOOLS,
  LEADERBOARD_DATA,
  CHALLENGE_PROGRAMS,
  TEACHER_TRAINING_PROGRAMS,
};
